/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Grid, Typography } from '@material-ui/core';

import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import Product from './Product';

import { Title, Header, Footer, RootContainer } from './other/style';
import DropzoneProducts from './DropzoneProducts';
import { displayInAppError } from '../../utils/toast/Toast';

import validateProducts from './other/validate';

import {
  deleteProduct,
  createStockBatch,
  resetImportProducts,
  openReviewProductDialog,
  closeReviewProductDialog,
  getBarcodeValues,
  openDeleteProductDialog,
  closeDeleteProductDialog
} from './other/actions';

import ProductDrawer from './ProductDrawer';
import CreateStockBatchSuccess from './CreateStockBatchSuccess';
import DialogDeleteProduct from './DialogDeleteProduct';

/**
 * Validation de toutes les produits importées.
 * dans l'import de produits
 *
 * @param  {Object} products         Tableaux de produits importées depuis le fichier
 * @param  {Object} barcodeValues    Tableaux de produits importées depuis le stock
 * @return {Object}              Object contenant toute les erreurs pour la commande
 */
const validate = (products, barcodeValues) => {
  products.forEach((product, index) => {
    validateProducts(product, { products, index, barcodeValues });
  });
};

/**
 * Fonction de retour vers le menu stock de la web app
 *
 * @param  {Object} history         Historique de navigation
 * @param  {Object} dispatchResetImportProducts    action du dispatcher pour mettre à jour le state
 */
const dispatchAndBack = (history, dispatchResetImportProducts) => {
  history.push('/stock');
  dispatchResetImportProducts();
};

/**
 * Fonction component qui gére l'import de produit
 *
 * @param  {Object} products         Produits importer depuis un ficher excel
 * @param  {Object} currentProduct    Produit séléctioné par l'utilisateur
 * @param  {Object} currentProductIndex         L'index du produit séléectionner facilite l'update dans le reducer
 * @param  {Object} dispatchDeleteProduct    Action du dispatcher pour mettre à jour le state
 * @param  {Object} dispatchResetImportProducts         Action du dispatcher pour mettre à jour le state
 * @param  {Object} dispatchStockCreateBatch   Action du dispatcher pour mettre à jour le state
 * @param  {Object} openDeleteDialog         Ouvre le dialog de suppression de produits
 * @param  {Object} dispatchGetBarcodeValue    Action du dispatcher pour mettre à jour le state
 * @param  {Object} dispatchCloseDeleteDialog         Action du dispatcher pour mettre à jour le state
 * @param  {Object} dispatchOpenDeleteDialog    Action du dispatcher pour mettre à jour le state
 * @param  {Object} history         Historique de navigation
 * @param  {Object} barcodeValues    Tableaux contenant les réferences et les EAN13 du stock
 */
const ImportProducts = ({
  products,
  currentProduct,
  currentProductIndex,
  dispatchDeleteProduct,
  dispatchResetImportProducts,
  dispatchStockCreateBatch,
  dispatchOpenReviewDialog,
  createBatchSuccess,
  openDeleteDialog,
  dispatchGetBarcodeValue,
  dispatchCloseDeleteDialog,
  dispatchOpenDeleteDialog,
  history,
  barcodeValues
}) => {
  useEffect(() => {
    dispatchGetBarcodeValue();
  }, [dispatchGetBarcodeValue]);
  useEffect(() => {
    validate(products, barcodeValues);
  }, [products, barcodeValues]);
  const importProducts = () => {
    validate(products, barcodeValues);
    let containError = false;
    let containWarning = false;
    products.forEach(product => {
      if (product.errorsItem && product.errorsItem.length) {
        containError = true;
      }
      if (product.warnings && product.warnings.length) {
        containWarning = true;
      }
    });
    if (containError) {
      displayInAppError(
        "Veuillez corriger les erreurs avant d'importer vos commandes"
      );
    } else if (containWarning) {
      displayInAppError(
        "Veuillez corriger les avertissement avant d'importer vos commandes"
      );
    } else {
      dispatchStockCreateBatch({ products });
    }
  };
  return (
    <RootContainer>
      <Header>
        <Title>Import de produits</Title>
        {!createBatchSuccess ? (
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              dispatchAndBack(history, dispatchResetImportProducts)
            }
          >
            <KeyboardArrowLeft style={{ marginRight: 5 }} />
            Retour état de stock
          </Button>
        ) : null}
      </Header>
      {createBatchSuccess ? (
        <CreateStockBatchSuccess />
      ) : (
        <>
          <div>
            <DialogDeleteProduct
              isOpen={openDeleteDialog}
              handleCloseDialogDeleteProduct={dispatchCloseDeleteDialog}
              product={currentProduct}
              index={currentProductIndex}
              onDelete={dispatchDeleteProduct}
            />
            <div hidden={products.length}>
              <DropzoneProducts />
            </div>
            <div>
              <Grid
                container
                style={{ height: '80vh', overflow: 'scroll', padding: 10 }}
              >
                {products.map((product, index) => (
                  <Grid item xs={12} md={6} xl={4} key={index}>
                    <Product
                      product={product}
                      label={product.name}
                      variant="outlined"
                      onClick={() => dispatchOpenReviewDialog(product, index)}
                      onDelete={() => dispatchOpenDeleteDialog(product, index)}
                    />
                  </Grid>
                ))}
              </Grid>
            </div>
          </div>
          <ProductDrawer />
        </>
      )}
      <Footer hidden={!products.length} style={{ marginTop: '2vh' }}>
        <Grid container>
          <Grid item xs={8} md={8}>
            <Typography hidden={!products.length} variant="h4" component="h4">
              Nombre de produits : {products.length}
            </Typography>
          </Grid>
          <Grid item xs={4} md={4}>
            <div style={{ textAlign: 'end', margin: '20' }}>
              <Button
                style={{ marginRight: 10 }}
                variant="contained"
                color="secondary"
                onClick={() => dispatchResetImportProducts()}
              >
                Réinitialiser
              </Button>
              <Button
                style={{ marginLeft: 10 }}
                variant="contained"
                color="primary"
                onClick={importProducts}
              >
                Importer
              </Button>
            </div>
          </Grid>
        </Grid>
      </Footer>
    </RootContainer>
  );
};

const mapStateToProps = state => ({
  products: state.importProducts.products,
  currentProduct: state.importProducts.currentProduct,
  productsAreInStock: state.importCommands.productsAreInStock,
  currentProductIndex: state.importProducts.index,
  openReviewProductDialog: state.importProducts.openReviewProductDialog,
  openDeleteDialog: state.importProducts.openDeleteDialog,
  createBatchSuccess: state.importCommands.createBatchSuccess,
  openDialogDelete: state.importCommands.openDialogDelete,
  barcodeValues: state.importProducts.barcodeValues
});

const mapDispatchToProps = dispatch => ({
  dispatchDeleteProduct: index => dispatch(deleteProduct(index)),
  dispatchStockCreateBatch: products => dispatch(createStockBatch(products)),
  dispatchGetBarcodeValue: () => dispatch(getBarcodeValues()),
  dispatchResetImportProducts: () => dispatch(resetImportProducts()),
  dispatchOpenDeleteDialog: (product, index) =>
    dispatch(openDeleteProductDialog(product, index)),
  dispatchCloseDeleteDialog: () => dispatch(closeDeleteProductDialog()),
  dispatchOpenReviewDialog: (product, index) =>
    dispatch(openReviewProductDialog(product, index)),
  dispatchCloseReviewDialog: () => dispatch(closeReviewProductDialog)
});

ImportProducts.propTypes = {
  products: PropTypes.array.isRequired,
  currentProduct: PropTypes.object.isRequired,
  currentProductIndex: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  openDeleteDialog: PropTypes.bool.isRequired,
  dispatchDeleteProduct: PropTypes.func.isRequired,
  dispatchOpenDeleteDialog: PropTypes.func.isRequired,
  dispatchCloseDeleteDialog: PropTypes.func.isRequired,
  dispatchStockCreateBatch: PropTypes.func.isRequired,
  dispatchResetImportProducts: PropTypes.func.isRequired,
  dispatchOpenReviewDialog: PropTypes.func.isRequired,
  dispatchGetBarcodeValue: PropTypes.func.isRequired,
  createBatchSuccess: PropTypes.bool.isRequired,
  barcodeValues: PropTypes.array.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ImportProducts));
